import { render, staticRenderFns } from "./BeneficialOwners.vue?vue&type=template&id=13468064&scoped=true&"
import script from "./BeneficialOwners.vue?vue&type=script&lang=js&"
export * from "./BeneficialOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13468064",
  null
  
)

export default component.exports